export default class LineFunctionResult {
  constructor(points, label) {
    this.points = points;
    this.label = label;
  }
}